<style scoped lang="scss">

</style>

<template>
	<div style="display: inline;">
		<yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/system/auth/role/page" getKey="rows"
			:columns="columns">
			<template #conditions>
				<!-- label-width="68px" -->
				<el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
					<el-form-item :label="$t('juesemingcheng')">
						<el-input v-model="yt.conditions.name"></el-input>
					</el-form-item>
					<el-form-item>
						<el-button @click="yt.get(1)" type="primary" plain>
							{{$t('sousuo')}}
						</el-button>
						<el-button @click="yt.clear()">{{$t('chongzhi')}}
						</el-button>
						<yi_curd_expand_button></yi_curd_expand_button>
					</el-form-item>
				</el-form>
			</template>
			<template #buttonsL>
				<el-button size="mini" @click="yt.showEditDialog('xinzeng',null,'w1')" type="primary">
					{{$t('xinzeng')}}
				</el-button>
			</template>
			<template #caozuo="scope">
				<el-row :gutter="10">
					<el-col :span="0.1">
						<el-button type="text" @click="yt.showEditDialog('bianji', scope.row,'w1')">{{$t('bianji')}}
						</el-button>
					</el-col>
					<el-col :span="0.1">
						<el-button type="text" class="font-color-danger"
							@click="yt.remove(scope.row,'/web/system/auth/role/delete')">{{$t('shanchu')}}</el-button>
					</el-col>
				</el-row>
			</template>

			<template #footer>
				<!-- 这里可以在底部填写东西 -->
			</template>
		</yi_curd_table>

		<el-dialog class="abow_dialog" :show-close="true" :title="$t(yt.editObj.action)"
			:visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body>
			<!-- 新增弹窗 -->
			<template v-if="yt.editObj.action == 'xinzeng'">
				<div class="dialog-scroller">
					<el-form :inline="true" ref="form" size="mini">
						<el-form-item :label="$t('juesemingcheng')" required>
							<el-input v-model="yt.editObj.name"></el-input>
						</el-form-item>
						<div>
							<span
								style="font-size: 2px; color: #989898;">{{$t('qingzaixiafangxuanzecaidanyuanniu')}}</span>
						</div>
						<el-tabs v-model="current_tab">
							<!-- 搜索框 -->
							<el-form-item size="mini">
								<el-input :placeholder="$t('qingshuruguanjianci')" v-model="filterText">
								</el-input>
							</el-form-item>
							<!-- <el-tab-pane label="Admin" name="first">
								<el-tree ref="treeAdmin" :data="menus[0]" show-checkbox node-key="id"
									:default-expand-all="true" :default-checked-keys="yt.editObj.menuIds">
								</el-tree>
							</el-tab-pane> -->
							<el-tab-pane label="Web" name="first">
								<el-tree ref="treeWeb" :data="menus[1]" show-checkbox node-key="id"
									:default-expand-all="true" :default-checked-keys="yt.editObj.menuIds"
									class="filter-tree" :filter-node-method="filterNode">
								</el-tree>
							</el-tab-pane>
							<el-tab-pane label="App" name="second">
								<el-tree ref="treeApp" :data="menus[2]" show-checkbox node-key="id"
									:default-expand-all="true" :default-checked-keys="yt.editObj.menuIds"
									class="filter-tree" :filter-node-method="filterNode">
								</el-tree>
							</el-tab-pane>
							<el-tab-pane label="Pad" name="third">
								<el-tree ref="treePad" :data="menus[3]" show-checkbox node-key="id"
									:default-expand-all="true" :default-checked-keys="yt.editObj.menuIds"
									class="filter-tree" :filter-node-method="filterNode">
								</el-tree>
							</el-tab-pane>
						</el-tabs>
					</el-form>
				</div>
				<!--注意，el-dialog的slot不能写成#footer-->
				<template slot="footer" class="dialog-footer">
					<el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
					<el-button size="mini" @click="yt.req('POST','/web/system/auth/role/create',beforeAddOrUpdate)"
						type="primary">{{$t('baocun')}}
					</el-button>
				</template>
			</template>
			<!-- 编辑弹窗 -->
			<template v-if="yt.editObj.action == 'bianji'">
				<!-- <el-tree :data="treeList(1)" show-checkbox node-key="id" :default-expanded-keys="[2, 3]"
					:default-checked-keys="[5]" :props="defaultProps">
				</el-tree>
				 -->
				<div class="dialog-scroller">
					<el-form :inline="true" ref="form" size="mini">
						<el-form-item :label="$t('juesemingcheng')" required>
							<el-input v-model="yt.editObj.name"></el-input>
						</el-form-item>
						<div>
							<span
								style="font-size: 2px; color: #989898;">{{$t('qingzaixiafangxuanzecaidanyuanniu')}}</span>
						</div>
						<el-tabs v-model="current_tab">
							<!-- 搜索框 -->
							<el-form-item size="mini">
								<el-input :placeholder="$t('qingshuruguanjianci')" v-model="filterText">
								</el-input>
							</el-form-item>
							<!-- <el-tab-pane label="Admin" name="first">
								<el-tree ref="treeAdmin" :data="menus[0]" show-checkbox node-key="id"
									:default-expand-all="true" :default-checked-keys="yt.editObj.menuIds">
								</el-tree>
							</el-tab-pane> -->
							<el-tab-pane label="Web" name="first">
								<el-tree ref="treeWeb" :data="menus[1]" show-checkbox node-key="id"
									:default-expand-all="true" :default-checked-keys="yt.editObj.menuIds"
									class="filter-tree" :filter-node-method="filterNode">
								</el-tree>
							</el-tab-pane>
							<el-tab-pane label="App" name="second">
								<el-tree ref="treeApp" :data="menus[2]" show-checkbox node-key="id"
									:default-expand-all="true" :default-checked-keys="yt.editObj.menuIds"
									class="filter-tree" :filter-node-method="filterNode">
								</el-tree>
							</el-tab-pane>
							<el-tab-pane label="Pad" name="third">
								<el-tree ref="treePad" :data="menus[3]" show-checkbox node-key="id"
									:default-expand-all="true" :default-checked-keys="yt.editObj.menuIds"
									class="filter-tree" :filter-node-method="filterNode">
								</el-tree>
							</el-tab-pane>
						</el-tabs>
					</el-form>
				</div>
				<!--注意，el-dialog的slot不能写成#footer-->
				<span slot="footer" class="dialog-footer">
					<el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
					<el-button size="mini" @click="yt.req('POST','/web/system/auth/role/update',beforeAddOrUpdate)"
						type="primary">{{$t('baocun')}}
					</el-button>
				</span>
			</template>

		</el-dialog>
	</div>
</template>
<script type="text/javascript">
	export default {
		name: 'admin_global_role_list',
		components: {},
		mixins: [],
		data() {
			return {
				filterText: '',
				current_tab: 'first',
				menus: [],
				columns: [{
						label: 'juesemingcheng',
						prop: 'name',
					},
					{
						label: 'createBy',
						prop: 'createByObject.nickname'
					},
					{
						label: 'createTime',
						prop: 'createTime',
						type: 'time',
					},
					{
						label: 'updateBy',
						prop: 'updateByObject.nickname',
					},
					{
						label: 'updateTime',
						prop: 'updateTime',
						type: 'time',
					},
					{
						label: 'caozuo',
						type: 'slot',
						width: 130,
						fixed: 'right',
					},
				]
			};
		},
		created() {

			setTimeout(() => {
				this.yt.SELECT_URL = "/web/system/auth/role/getRoleByIds"
				this.yt.SELECT_RESULT_KEY = "data"
				this.yt.SELECT_ID = "id"
				this.yt.SELECT_TITLE = "name"
				this.yt.get(1)
				this.getAdminMenus()
			}, 300)

		},
		watch: {
			filterText(val) {
				// 树结构 - 根据关键字搜索
				this.$refs.treeWeb.filter(val);
				this.$refs.treeApp.filter(val);
				this.$refs.treePad.filter(val);
			}
		},
		mounted() {

		},

		destroyed() {},

		computed: {


		},
		activated() {},
		methods: {
			// 关键字过滤方法
			filterNode(value, data) {
				if (!value) return true;
				return data.label.indexOf(value) !== -1;
			},
			beforeAddOrUpdate(params) {
				// params.menuIds = [...this.$refs.treeAdmin.getCheckedKeys(), ...this.$refs.treeWeb.getCheckedKeys(), ...this
				// 	.$refs.treeApp.getCheckedKeys(), ...this.$refs.treePad.getCheckedKeys()
				// ]
				params.menuIds = [...this.$refs.treeWeb.getCheckedKeys(), ...this
					.$refs.treeApp.getCheckedKeys(), ...this.$refs.treePad.getCheckedKeys()
				]
				return params
			},
			getAdminMenus() {
				//先查询出所有平台的菜单
				this.menus = new Array(4)
				for (var i = 0; i < 4; i++) {

					((i) => {
						this.http.get('web/system/auth/menu/treeList', {
							params: {
								platform: i + 1
							}
						}).then(res => {
							this.menus[i] = res.data.rows.map(item => {
								//二级
								let children1
								if (item.children) {
									children1 = item.children.map(item2 => {

										//三级
										let children2
										if (item2.children) {
											children2 = item2.children.map(item3 => {
												return {
													label: this.$t(item3.code),
													id: item3.id
												}
											})
										}
										return {
											label: this.$t(item2.code),
											id: item2.id,
											children: children2
										}
									})
								}

								return {
									label: this.$t(item.code),
									id: item.id,
									children: children1
								}
							})
						});
					})(i)

				}

			},
		},
	};
</script>
